import { getBooleanFromValue } from '@/global/utils/utils'
import { api } from '@/global/services/api'

const TAB_KEY = 'digitalOutputs'
export default {
  data () {
    return {
      digitalOutputsAutocompleteItems: []
    }
  },

  computed: {
    digitalOutputsConfig () {
      return {
        title: this.$t('base/tracker.digital_outputs'),
        key: TAB_KEY,
        visible: getBooleanFromValue(this.permissions?.canReadDigitalOutputs),
        onLoad: () => this.onDigitalOutputsTabLoad(),
        apiConfig: {
          get: {
            module: 'base',
            route: `tracker/${this.resolveRouteParamValue('id')}/digital-outputs`
          },
          post: {
            module: 'base',
            route: `tracker/${this.resolveRouteParamValue('id')}/digital-outputs`
          }
        },
        modifyDataBeforeSend: (event) => this.onModifyDigitalOutputsBeforeSend(event),
        tabContent: [
          {
            component: this.tabActionButtonsComponent,
            title: this.$t('base/tracker.digital_outputs'),
            showBackButton: {
              onGoBack: () => this.navigatesToTableView(this.trackersOverviewViewName)
            }
          },
          {
            component: this.columnsContentComponent,
            showButtons: false,
            rows: [
              {
                type: 'fields',
                columnsCount: 2,
                fields: [
                  {
                    key: 'dout1',
                    label: this.$t('base/tracker.dout1'),
                    type: 'autocomplete',
                    items: this.digitalOutputsAutocompleteItems,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'dout2',
                    label: this.$t('base/tracker.dout2'),
                    type: 'autocomplete',
                    items: this.digitalOutputsAutocompleteItems,
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  },

  methods: {
    async onDigitalOutputsTabLoad () {
      try {
        const { data } = await api('base').get('digital-outputs/autocomplete')
        if (data?.length) {
          this.digitalOutputsAutocompleteItems = data
        }
      }
      catch (exception) {
        console.error(exception)
      }
    },

    onModifyDigitalOutputsBeforeSend (event) {
      const { copiedData } = event || {}
      copiedData.dout1 = copiedData?.dout1?.id || copiedData?.dout1
      copiedData.dout2 = copiedData?.dout2?.id || copiedData?.dout2
      return copiedData
    }
  }
}
